import { render, staticRenderFns } from "./IssueComments.vue?vue&type=template&id=13e8dc58&scoped=true&"
import script from "./IssueComments.vue?vue&type=script&lang=js&"
export * from "./IssueComments.vue?vue&type=script&lang=js&"
import style0 from "./IssueComments.vue?vue&type=style&index=0&id=13e8dc58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e8dc58",
  null
  
)

export default component.exports